import { render, staticRenderFns } from "./StartVectorNotification.vue?vue&type=template&id=579084a1&scoped=true"
import script from "./StartVectorNotification.vue?vue&type=script&lang=js"
export * from "./StartVectorNotification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "579084a1",
  null
  
)

export default component.exports